import isEmpty from 'lodash-es/isEmpty'
import omit from 'lodash-es/omit'

import { ENTITY_LISTING_VIEW_TYPE } from '../../../constants/common'
import { isListViewTypeBoard } from '../../../utils/listViewType'
import { EXCLUDE_FILTERS } from '../../Filter'

export function getApplicantsHasActiveFilters(filterValues) {
  return !isEmpty(omit(filterValues, EXCLUDE_FILTERS))
}

export function getApplicantsRefreshErrorText({
  availableFilters,
  filterValues,
  t,
}) {
  const activeFilterTitles = availableFilters
    .filter(filter =>
      [filter.query_param].flat().some(param => filterValues?.[param])
    )
    .map(filter => t(filter.title))

  return activeFilterTitles.length > 0
    ? t('RentalPortal.ApplicantsRefreshErrorFiltersKey', {
        filters: activeFilterTitles.join(', '),
      })
    : t('RentalPortal.ApplicantsRefreshErrorKey')
}

export function getIsApplicantsTableEmpty({ applicants, isLoading }) {
  return applicants.length === 0 && !isLoading
}

export function getApplicantsListViewType(view) {
  return isListViewTypeBoard(view)
    ? ENTITY_LISTING_VIEW_TYPE.board
    : ENTITY_LISTING_VIEW_TYPE.table
}

export function getApplicantsBoardRefreshResult([tableResult, isBoardRead]) {
  return isBoardRead && tableResult
}
